var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button',{class:[
    'owc-header-button__iconWrapper',
    { 'owc-header-button--flyout-open': _vm.open, 'owc-header-button__iconWrapper--light': _vm.lightMode },
  ],attrs:{"aria-label":_vm.displayLabel}},[_c('wb-icon',{class:[
      `owc-header-button__icon${_vm.isIconSmall ? '--small' : ''}`,
      { 'owc-header-button__badge': _vm.shouldDisplayBadge },
    ],attrs:{"name":_vm.displayIcon}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }